import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { environment } from '../../../environments/environment'
import { JSONRpcResponse } from '../../Interfaces/JSONRpcResponse'
import { JSONRpc } from '../service-jsonrpc'

@Injectable({
	providedIn: 'root',
})
export class FormulaireService {
	constructor(private http: HttpClient) { }

	getChampsHistorique(
		idChamp: any,
		idMembre: any,
		options: any = []
	): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.formulaire:getChampsHistorique',
			params: {
				idChamp: idChamp,
				idMembre: idMembre,
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	v3_getChampsHistorique(
		idChamp: any,
		idMembre: any,
		options: any = []
	): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.formulaire:v3_getChampsHistorique',
			params: {
				idChamp: idChamp,
				idMembre: idMembre,
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	new(idAForm: any, options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.formulaire:new',
			params: {
				idAForm: idAForm,
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	new_v3(code: string, options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.formulaire:new_v3',
			params: {
				code: code,
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	set(
		type: any,
		idForm: any,
		idDemande: any,
		options: any = []
	): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.formulaire:set',
			params: {
				type: type,
				idForm: idForm,
				idDemande: idDemande,
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	get(id: any, options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.formulaire:get',
			params: {
				id: id,
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	disableForm(id: any, options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.formulaire:disableForm',
			params: {
				id: id,
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	list(options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.formulaire:list',
			params: {
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	listByCode(codes: any[], options: []) {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.formulaire:listbycodes',
			params: {
				codes: codes,
				options: options
			}
		})
		return this.http.post<JSONRpcResponse>(environment.webservice, rpcMethod);
	}

	listForIntervention(options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.formulaire:listForIntervention',
			params: {
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	v3_getByCode(code: string, options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.formulaire:v3_getByCode',
			params: {
				code: code,
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	getTypeList(options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.formulaire:getTypeList',
			params: {
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	getObserveFields(keys: any[], options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.formulaire:getObserveFields',
			params: {
				keys: keys,
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	getObserveField(key: any, options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.formulaire:getObserveField',
			params: {
				key: key,
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	tirggerLockObserve(fields: any, options: any = []): Observable<JSONRpcResponse> {

		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.formulaire:tirggerLockObserve',
			params: {
				fields: fields,
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)

	}
	init(arrayId: any, instruction: any): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.formulaire:init',
			params: {
				types: arrayId,
				options: {
					instruction: instruction.ID,
					demande: instruction.demande.ID,
				},
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	demandes(
		demandeid: any,
		_nodata?: boolean,
		 visit: any = []
	): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.formulaire:demandes',
			params: {
				options: {
					demande: demandeid,
					noValue: _nodata,
					visit:visit
				},
			},
		})

		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

    getformulairelist(id: any, options: any = []): Observable<JSONRpcResponse> {

		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.dossier:getformulairelist',
			params: {
				id: id,
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)

	}

    addDocumentsAtForm(id: any, options: any = []): Observable<JSONRpcResponse> {

		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.formulaire:addDocumentsAtForm',
			params: {
				id: id,
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)

	}

    removeFormulaireAtDocument(id: any, options: any = []): Observable<JSONRpcResponse> {

		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.formulaire:removeFormulaireAtDocument',
			params: {
				id: id,
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)

	}
}
